import { Modal, Paper } from "@mui/material";
import React, { useEffect, useState } from "react";

export default function Loading({
  title = "Please wait!",
  message = "We’re getting things ready for you. Thanks for your patience.",
  buttonTitle = "",
  onClickButton,
}) {
  const [timeLeft, setTimeLeft] = useState(10);

  useEffect(() => {
    if (timeLeft > 0) {
      setTimeout(() => {
        setTimeLeft(timeLeft - 1);
      }, 1000);
    }
  }, [timeLeft]);

  return (
    <Modal open>
      <div className="flex items-center justify-center min-h-[100vh] bg-black bg-opacity-70">
        <div
          className="p-6 shadow-xl w-96 bg-gray-800 rounded-3xl"
          sx={{ borderRadius: 3 }}
        >
          <div className="flex flex-col items-center justify-center">
            {/* Compact multi-layer circle animation */}
            <div className="relative w-20 h-20">
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="w-16 h-16 border-2 border-dashed border-gray-500 rounded-full animate-rotate-slow"></div>
              </div>
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="text-center">
                  <svg
                    className="w-5 h-5 text-blue-400 animate-pulse mx-auto"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M12 8v4l3 3m-9 5h12a2 2 0 002-2V7a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
                    />
                  </svg>
                </div>
              </div>
            </div>

            {/* Loading Text */}
            <div className="mt-4 text-center">
              <h2 className="text-xl font-semibold text-white">{title}</h2>
              <p className="mt-3 text-gray-300 text-sm">{message}</p>
            </div>

            {/* Button */}
            <div className="my-4">
              {buttonTitle && (
                <button
                  className="bg-blue-600 text-white px-4 py-2 rounded text-sm hover:bg-blue-700 duration-300 disabled:bg-gray-600 disabled:cursor-not-allowed"
                  disabled={timeLeft > 0}
                  onClick={onClickButton}
                >
                  {timeLeft > 0 ? timeLeft : buttonTitle}
                </button>
              )}
            </div>

            {/* Footer text */}
            <div className="text-xs text-gray-500 text-center">
              <p>Processing your request...</p>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
}
